export default __webpack_public_path__ + "static/men1-81170a9837bc4ef80309719cf06f1dbd.webp";